import React, { useContext } from 'react';
import { appContext } from '../../App';
import { lang } from '../../util/constants'
import amazonLogo from '../../images/amazon-logo.png'
import walmartLogo from '../../images/walmart-logo.jpg'

import './wishlist.css';

const WishList = () => {
   
   const { language } = useContext(appContext);

   const heading = language === lang.pt ? 'Visite nossa lista de presentes' : 'Visit our wishlist';

   return (
      <div className='wishlist-container' id='wishlist-container'>
         <div className='wishlist-layer'>
            <div className='wishlist-content padd'>
               <h2>{heading}</h2>
               <div className='list-buttons'>
                  <a className='amazon-button' href='https://www.amazon.ca/baby-reg/2A5ZNEFY5WRDX' target='_blank'>
                     <img src={amazonLogo} alt='Amazon Button' />
                  </a>
                  {/* <a className='walmart-button' href='https://www.walmart.ca/en/registry/baby/gl394350354' target='_blank'>
                     <div className='wb-overlay'>
                        <img className='walmart-button' src={walmartLogo} alt='Wallmart Button'/>
                     </div>
                  </a> */}
               </div>
            </div>
         </div>
      </div>
   )
}

export default WishList
